import React, { useState } from "react";
import {
  Container,
  Card,
  Button,
  ListGroup,
  Modal
} from "react-bootstrap";
import { CheckCircle, Star, ChevronDown, ChevronUp } from "lucide-react";
import Palette from "../../Palette";
import { Link } from "react-router-dom";

export default function MitraRegisterPage() {
  const [showDetail, setShowDetail] = useState(false);
  const [openSections, setOpenSections] = useState({});
  let isLoggedIn = !!localStorage.getItem('user')
  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const benefits = [
    "Mendapat pengakuan resmi sebagai mitra HPI",
    "Berhak menggunakan status Mitra Swasta Terdaftar HPI untuk kepentingan promosi sesuai ketentuan",
    "Dapat mengikuti kegiatan HPI yang relevan",
    "Hak-hak lain yang diputuskan berdasarkan diskresi Ketua Umum HPI dan tidak melanggar ketentuan dalam Anggaran Dasar dan Anggaran Rumah Tangga HPI yang berlaku",
  ];

  const requirements = [
    "Berbadan Hukum (PT, CV, Yayasan, dll)",
    "Bergerak di bidang layanan bahasa (penerjemahan, penjurubahasaan, dsb.)",
    "Tidak sedang terlibat perkara hukum yang merugikan profesi penerjemah/juru bahasa",
    "Bersedia mematuhi AD/ART HPI serta kode etik dan perilaku HPI",
  ];

  const modalSections = [
    {
      title: "Dokumen yang Harus Disiapkan",
      content: `Calon mitra wajib menyiapkan:

1. Formulir pendaftaran resmi (disediakan oleh HPI)
2. Salinan akta pendirian perusahaan dan/atau legalitas badan usaha (SIUP/NIB/TDP)
3. Profil perusahaan (visi, misi, bidang layanan, portofolio utama)
4. Daftar penerjemah/juru bahasa yang bekerja sama atau berada di bawah koordinasi perusahaan (termasuk bukti keanggotaan HPI)
5. Surat pernyataan kesediaan mematuhi AD/ART HPI, Kode Etik dan Kode Perilaku HPI, dan ketentuan kerja sama
6. Bukti pembayaran biaya administrasi/pendaftaran`,
    },
    {
      title: "Alur Pendaftaran",
      content: `1. PENGAJUAN FORMULIR
   • Calon mitra mengisi dan mengajukan formulir beserta dokumen pendukung ke Sekretariat HPI (daring)

2. VERIFIKASI ADMINISTRATIF
   • Sekretariat HPI memeriksa kelengkapan dokumen dalam waktu 7 hari kerja
   • Jika ada kekurangan, calon mitra diberi waktu 14 hari kalender untuk melengkapi

3. EVALUASI DAN REKOMENDASI
   • Pengurus inti HPI (ketua, para wakil ketua, sekretaris dan bendahara) melakukan evaluasi reputasi, rekam jejak, dan kesesuaian bidang usaha
   • Hasil evaluasi berupa rekomendasi: diterima / ditolak / perlu klarifikasi lebih lanjut

4. PERSETUJUAN KETUA UMUM HPI
   • Berdasarkan hasil evaluasi dan rekomendasi Pengurus Inti, Ketua Umum memberikan persetujuan dan keputusan final
   • Keputusan final disampaikan tertulis kepada calon mitra

5. PEMBAYARAN BIAYA ADMINISTRASI MITRA
   • Jika diterima, calon mitra wajib membayar uang pendaftaran dan biaya administrasi tahunan sesuai ketentuan HPI

6. PENERBITAN SERTIFIKAT MITRA SWASTA TERDAFTAR
   • HPI menerbitkan sertifikat dan/atau surat keputusan sebagai bukti resmi status Mitra Swasta Terdaftar
   • Nama perusahaan dimasukkan dalam daftar resmi Mitra Swasta Terdaftar HPI di laman/web HPI`,
    },
    {
      title: "Kewajiban Mitra Terdaftar",
      content: `• Membayar biaya administrasi tahunan tepat waktu
• Menjaga nama baik HPI dan profesi penerjemah dan juru bahasa
• Mematuhi AD/ART, kode etik, dan ketentuan kerja sama
• Bersedia dievaluasi ulang secara periodik terkait status kemitraannya`,
    },
    {
      title: "Sanksi",
      content: `Mitra Swasta Terdaftar dapat dikenai teguran, pembekuan, atau pencabutan status jika:

• Melanggar ketentuan HPI
• Tidak membayar biaya administrasi tahunan
• Terbukti melakukan praktik yang merugikan profesi penerjemah dan juru bahasa atau merusak nama baik HPI`,
    },
  ];

  return (
    <Container className="py-4">
      {/* Judul */}
      <div className="text-center mb-5">
        <h1 className="fw-bold mb-3" style={{ color: Palette.PRIMARY }}>
          Keanggotaan Mitra HPI
        </h1>

        <Card className="border-0 shadow-sm">
          <Card.Body>
            <p
              className="mb-0"
              style={{ textAlign: "justify", lineHeight: "1.6" }}
            >
              Mitra HPI adalah pihak-pihak eksternal yang bekerja sama secara
              resmi dengan Himpunan Penerjemah Indonesia (HPI) untuk mendukung
              misi peningkatan kualitas, profesionalisme, dan standar layanan
              penerjemahan di Indonesia.
            </p>
          </Card.Body>
        </Card>
      </div>

      {/* Keuntungan */}
      <Card className="shadow-sm border-0 mb-5">
        <Card.Body>
          <h4 className="fw-bold mb-4 text-dark">
            Keuntungan Mitra Swasta Terdaftar
          </h4>
          <ListGroup variant="flush">
            {benefits.map((b, i) => (
              <ListGroup.Item
                key={i}
                className="d-flex align-items-center py-3 border-0"
                style={{ gap: "16px" }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "28px",
                    height: "28px",
                    backgroundColor: Palette.PRIMARY,
                    borderRadius: "50%",
                    flexShrink: 0,
                  }}
                >
                  <Star size={18} style={{ color: "white" }} fill="white" />
                </div>
                <span className="text-dark" style={{ lineHeight: "1.5" }}>
                  {b}
                </span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>

      {/* Persyaratan */}
      <Card className="shadow-sm border-0 mb-5">
        <Card.Body>
          <h4 className="fw-bold mb-4 text-dark">
            Persyaratan Utama Menjadi Mitra HPI
          </h4>

          <div className="d-flex justify-content-between align-items-start mb-4">
            <small className="text-muted me-3">
              Informasi Terkait Persyaratan Utama Untuk Bergabung Sebagai Mitra
              Swasta Terdaftar HPI. Klik Selengkapnya <br /> Untuk Membaca Detail
              Lengkapnya
            </small>
            <Button
              variant="link"
              className="p-0 fw-semibold"
              style={{
                color: Palette.PRIMARY,
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
              onClick={() => setShowDetail(true)}
            >
              Selengkapnya →
            </Button>
          </div>

          <ListGroup variant="flush">
            {requirements.map((r, i) => (
              <ListGroup.Item
                key={i}
                className="d-flex align-items-center py-3 border-0"
                style={{ gap: "16px" }}
              >
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "28px",
                    height: "28px",
                    backgroundColor: Palette.PRIMARY,
                    borderRadius: "50%",
                    flexShrink: 0,
                  }}
                >
                  <CheckCircle size={18} style={{ color: "white" }} />
                </div>
                <span className="text-dark" style={{ lineHeight: "1.6" }}>
                  {r}
                </span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
      {
        !isLoggedIn && <>
          <div className="text-center mt-5">
            <Link to="/mitra-swasta/register/form">
              <Button
                size="lg"
                style={{
                  backgroundColor: Palette.PRIMARY,
                  borderColor: Palette.PRIMARY,
                  padding: "12px 40px",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
                className="shadow"
              >
                Daftar Sekarang
              </Button>
            </Link>
          </div>
        </>
      }


      {/* Modal tanpa footer button */}
      <Modal show={showDetail} onHide={() => setShowDetail(false)} centered size="lg" scrollable>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">
            Detail Persyaratan dan Prosedur
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalSections.map((section, index) => (
            <Card key={index} className="mb-3 border-0 shadow-sm">
              <Card.Header
                className="bg-white border-0"
                onClick={() => toggleSection(index)}
                style={{ cursor: "pointer", borderRadius: "8px" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-bold text-dark">{section.title}</h6>
                  {openSections[index] ? (
                    <ChevronUp size={20} style={{ color: Palette.PRIMARY }} />
                  ) : (
                    <ChevronDown size={20} style={{ color: Palette.PRIMARY }} />
                  )}
                </div>
              </Card.Header>
              {openSections[index] && (
                <Card.Body
                  className="bg-light"
                  style={{ borderRadius: "0 0 8px 8px" }}
                >
                  <div
                    style={{ whiteSpace: "pre-line", lineHeight: "1.8" }}
                    className="text-dark"
                  >
                    {section.content}
                  </div>
                </Card.Body>
              )}
            </Card>
          ))}
        </Modal.Body>
      </Modal>
    </Container>
  );
}